import * as Config from '../../config'
import axios from 'axios'

const state = {
    userInfo: null,
    userInfoLoaded: false,
    access_token: null,
}

const actions = {
    login({ commit, dispatch }, data) {

        var postData = {
            client_id: 2,
            client_secret: Config.clientSecret,
            grant_type: 'password',
            username: data.email,
            password: data.password,
        }

        return axios.post(Config.apiPath + '/oauth/token', postData).then((response) => {
            commit('setAccessToken', response.data)
            return Promise.resolve()
        }).catch(error => {
            return error.response.status
        }).then(
            // get user info
            dispatch('getUserInfo')
        );
    },

    getUserInfo({commit}) {
        console.log('called')
        
        var header = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            }
        }

        return axios.get(Config.apiPath + '/api/user', header).then((response) => {
           
            if(Config.debugMode) console.log(response.data)
            
            commit('setUserInfo', response.data)

            return Promise.resolve(response)
            
        });

    },

    logout({commit}) {
        localStorage.removeItem('access_token');
        commit('clearUserInfo')
    }
}

const mutations = {
    setAccessToken(state, data) {
        console.log('setting access_token')
        state.access_token = data.access_token
        localStorage.setItem('access_token', data.access_token)
    },
    setUserInfo(state, data) {
        state.userInfo = data;
        state.userInfoLoaded = true;
        state.access_token = localStorage.getItem('access_token')
    },
    clearUserInfo(state) {
        state.userInfo = null
    }
}

const getters = {
    isAuthenticated: state => {
        return !!state.userInfo
    },

    userInfo: state => {
        return state.userInfo
    },

    getAuthorizationHeader() {
        var header = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + state.access_token
            }
        }

        return header;
    },
}

export default {
    state,
    mutations,
    getters,
    actions
}